"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlmeAuthorizationApiBase = void 0;
const RequestInitHandler_1 = require("../RequestInitHandler");
class AlmeAuthorizationApiBase {
    constructor(logger, httpHandler, settings) {
        this.Logger = logger;
        this.HttpHandler = httpHandler;
        this.Settings = settings;
        this.AlmeBaseUri =
            `${this.Settings.AlmeApiProtocol}${this.Settings.AlmeApiHostname}${this.Settings.AlmeApiBasePath}`;
    }
    PostAuthorizationAsync(authorizationRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const authorizationRequestInfo = `${this.AlmeBaseUri}${this.Settings.AlmeApiAuthorizationEndpoint}`;
            const authorizationRequestInit = new RequestInitHandler_1.default(this.Logger, this.Settings, 'POST', JSON.stringify(authorizationRequest));
            const response = yield this.HttpHandler.SendAsync(authorizationRequestInfo, authorizationRequestInit);
            if (typeof response !== 'object') {
                const error = new Error('Invalid Response');
                error.httpStatusCode = 401;
                throw error;
            }
            return response;
        });
    }
}
exports.AlmeAuthorizationApiBase = AlmeAuthorizationApiBase;
//# sourceMappingURL=AlmeAuthorizationApiBase.js.map


// WEBPACK FOOTER //
// ../../Authorization/AlmeAuthorizationApiBase.ts